module.exports = __webpack_public_path__ + "static/img/interested_img.4b428475.png";